import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { schoolApi } from '../../api/client';
import { FaSchool, FaMapMarkerAlt, FaPhone, FaEnvelope, FaArrowRight } from 'react-icons/fa';
import Spinner from '../../components/common/Spinner';

export default function SchoolLanding() {
  const { slug }   = useParams();
  const navigate   = useNavigate();
  const [school, setSchool] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');

  useEffect(() => {
    schoolApi.getInfo(slug)
      .then(r => setSchool(r.data.data))
      .catch(e => setError(e.response?.data?.message || 'School not found'))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div style={{ minHeight: '100vh', background: '#1a1a2e', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner color="#fff" /></div>;

  if (error) return (
    <div style={{ minHeight: '100vh', background: '#1a1a2e', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16, color: '#fff' }}>
      <FaSchool size={48} opacity={0.3} />
      <p style={{ color: '#ef4444' }}>{error}</p>
      <button onClick={() => navigate('/')} className="sms-btn sms-btn-outline" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}>← Back Home</button>
    </div>
  );

  const primary = school.primary_color || '#0d6efd';

  return (
    <div style={{ minHeight: '100vh', background: `linear-gradient(135deg, #1a1a2e, ${primary}44)` }}>
      {/* Header */}
      <div style={{ background: 'rgba(0,0,0,0.3)', backdropFilter: 'blur(8px)', padding: '16px 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: '0.85rem' }}>← All Schools</button>
        <button onClick={() => navigate(`/school/${slug}/login`)}
          className="sms-btn" style={{ background: primary, color: '#fff' }}>
          Login <FaArrowRight size={12} />
        </button>
      </div>

      {/* School hero */}
      <div style={{ textAlign: 'center', padding: '60px 20px 40px', color: '#fff' }}>
        {school.logo
          ? <img src={school.logo} alt="logo" style={{ width: 100, height: 100, borderRadius: 20, objectFit: 'cover', marginBottom: 20, boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }} />
          : <div style={{ width: 100, height: 100, borderRadius: 20, background: primary, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', boxShadow: '0 8px 32px rgba(0,0,0,0.3)' }}>
              <FaSchool size={44} color="#fff" />
            </div>
        }
        <h1 style={{ fontSize: '2.2rem', fontWeight: 800, marginBottom: 8 }}>{school.name}</h1>
        {school.motto && <p style={{ color: '#d1d5db', fontStyle: 'italic', fontSize: '1.05rem', marginBottom: 24 }}>"{school.motto}"</p>}

        <button onClick={() => navigate(`/school/${slug}/login`)}
          className="sms-btn" style={{ background: primary, color: '#fff', fontSize: '1rem', padding: '12px 32px', borderRadius: 12 }}>
          Login to Your Portal <FaArrowRight size={13} />
        </button>
      </div>

      {/* Info cards */}
      <div style={{ maxWidth: 700, margin: '0 auto', padding: '0 20px 60px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(200px,1fr))', gap: 16 }}>
        {school.address && (
          <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 14, padding: 20, color: '#fff' }}>
            <FaMapMarkerAlt style={{ marginBottom: 8, color: primary }} />
            <div style={{ fontSize: '0.8rem', color: '#9ca3af', marginBottom: 4 }}>Address</div>
            <div style={{ fontSize: '0.9rem' }}>{school.address}</div>
          </div>
        )}
        {school.phone && (
          <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 14, padding: 20, color: '#fff' }}>
            <FaPhone style={{ marginBottom: 8, color: primary }} />
            <div style={{ fontSize: '0.8rem', color: '#9ca3af', marginBottom: 4 }}>Phone</div>
            <div style={{ fontSize: '0.9rem' }}>{school.phone}</div>
          </div>
        )}
        {school.email && (
          <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 14, padding: 20, color: '#fff' }}>
            <FaEnvelope style={{ marginBottom: 8, color: primary }} />
            <div style={{ fontSize: '0.8rem', color: '#9ca3af', marginBottom: 4 }}>Email</div>
            <div style={{ fontSize: '0.9rem' }}>{school.email}</div>
          </div>
        )}
        {school.principal_name && (
          <div style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 14, padding: 20, color: '#fff' }}>
            <FaSchool style={{ marginBottom: 8, color: primary }} />
            <div style={{ fontSize: '0.8rem', color: '#9ca3af', marginBottom: 4 }}>Principal</div>
            <div style={{ fontSize: '0.9rem' }}>{school.principal_name}</div>
          </div>
        )}
      </div>
    </div>
  );
}
